import { EVENTS } from '@archetype-themes/utils/events'

class CloseCart extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController()

    // Trigger to close cart drawer
    this.cartCloseButton = document.querySelector('.js-close-header-cart')

    if (!this.cartCloseButton) return
    this.cartCloseButton.addEventListener('click', this.handleClick.bind(this), { signal: this.abortController.signal })
  }

  handleClick(evt) {
    evt.preventDefault()
    evt.target.dispatchEvent(new CustomEvent(EVENTS.cartClose, { bubbles: true }))
  }

  disconnectedCallback() {
    this.abortController.abort()
  }
}

customElements.define('close-cart', CloseCart)

document.querySelector('header-cart-drawer').addEventListener('click', function (event) {
  const closeButton = event.target.closest('.js-close-header-cart');

  if (closeButton) {
    // Skip if the click was directly on an <a> or inside one
    if (event.target.closest('a')) {
      return; // Allow anchor default behavior
    }

    const closeCartElement = document.querySelector('close-cart');
    if (closeCartElement) {
      closeCartElement.click();
    }
  }
});

